import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabStripModule, PanelBarModule } from '@progress/kendo-angular-layout';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';

import { PipesModule } from '../pipes/pipes.module';
import { FormDialogComponent } from './form-dialog.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { DataGridModule } from '../data-grid/data-grid.module';
import { GridModule } from '@progress/kendo-angular-grid';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';


@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ButtonGroupModule,
        ButtonsModule,
        CommonModule,
        TabStripModule,
        PanelBarModule,
        SwitchModule,
        NumericTextBoxModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        DialogModule,
        UploadModule,
        PipesModule,
        DateInputsModule,
        MatButtonModule,
        SortableModule,
        DataGridModule,
        GridModule,
        MatTooltipModule,
    ],
    declarations: [
        FormDialogComponent,
    ],
    exports: [
        FormDialogComponent
    ],
    providers: [],

})
export class FormDialogModule { }
